import type { ClienteAutenticado } from '@pgcustom/shared-types';

type OuvintePortalSessao = (cliente: ClienteAutenticado | null) => void;

/**
 * Mesmo padrão de `parceiro-portal/portal-parceiro.session.ts`, mas
 * para o contexto do Portal do Cliente — deliberadamente uma instância
 * separada, nunca compartilhada com `sessionStore` (Auth interno) nem
 * com `portalParceiroSessionStore`. NUNCA persiste em `localStorage` —
 * a sessão real vive no cookie `httpOnly` `pg_portal_cliente_session`,
 * controlado pelo backend; este store só espelha o que
 * `GET /portal-clientes/me` respondeu.
 */
export class PortalClienteSessionStore {
  private cliente: ClienteAutenticado | null = null;
  private readonly ouvintes = new Set<OuvintePortalSessao>();

  obterCliente(): ClienteAutenticado | null {
    return this.cliente;
  }

  estaAutenticado(): boolean {
    return this.cliente !== null;
  }

  definirCliente(cliente: ClienteAutenticado | null): void {
    this.cliente = cliente;
    this.ouvintes.forEach((ouvinte) => ouvinte(cliente));
  }

  inscrever(ouvinte: OuvintePortalSessao): () => void {
    this.ouvintes.add(ouvinte);
    return () => this.ouvintes.delete(ouvinte);
  }
}

export const portalClienteSessionStore = new PortalClienteSessionStore();
